import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '../lib/cache'
import { toCamelCase } from '../lib/typeHelper'

export interface SearchResult {
  model: string
  id: string
  headline: string
  text: string
  link: string | null
  context?: string | null
}

export const MIN_SEARCH_LENGTH = 2

export function useGlobalSearch(query: string) {
  const trimmed = query.trim()
  return useQuery({
    queryKey: [CacheKeys.GLOBAL_SEARCH, trimmed],
    queryFn: () =>
      axios
        .get('/api/v1/insure/internal/search/', { params: { q: trimmed } })
        .then((response) => toCamelCase(response.data.results) as SearchResult[]),
    enabled: trimmed.length >= MIN_SEARCH_LENGTH,
    staleTime: 30_000,
  })
}
